import React from 'react';
import { useJobFormContext } from 'parent-portal/forms/JobFormContext';
import JobFormPage from '../JobFormPage';
import { useKidPetContext } from 'parent-portal/forms/contexts/KidPetContext';
import { useUserContext } from 'UserContext';
import KidSelectionInput from '../../KidSelectionInput';
import { Kid } from 'models/Kid';
import { FieldStates } from '../../FormTypes';
import JobTitleInput from './JobTitleInput';
import JobDescriptionInput from './JobDescriptionInput';
import { Grid } from '@material-ui/core';

interface IDependentsPage {
    kids: Kid[];
    headline: string;
    comments: string;
}

interface IProps {
    fieldStates: FieldStates<IDependentsPage>;
    showDependents: boolean;
}

export default function DependentsPage({ fieldStates: { kids, headline, comments }, showDependents }: IProps) {
    const { goToNext } = useJobFormContext();
    const { user } = useUserContext();
    const { postFamilyKids, validateKidPetInfo } = useKidPetContext();
    const { form } = useJobFormContext();

    async function onNextClicked() {
        if (user?.family[0].id) {
            await postFamilyKids(user.family[0].id);
        }

        goToNext();
    }

    function pageIsValid() {
        return headline.isValid && comments.isValid && (!showDependents || kids.isValid || validateKidPetInfo());
    }

    return (
        <JobFormPage onNextClicked={onNextClicked} nextDisabled={!pageIsValid()} id="description-page">
            <Grid container direction="column" style={{ marginTop: 20 }}>
                <Grid style={{ flexGrow: 1 }}>
                    <JobTitleInput title={headline} />
                </Grid>
                <Grid style={{ flexGrow: 1, marginTop: 20 }}>
                    <JobDescriptionInput description={comments} />
                </Grid>
                {showDependents && (
                    <Grid style={{ flexGrow: 1, marginTop: 20 }}>
                        <KidSelectionInput kids={kids} />
                    </Grid>
                )}
            </Grid>
        </JobFormPage>
    );
}
